import debounce from 'lodash-es/debounce'
import {useCallback, useEffect, useMemo, useState} from 'react'

import {useFilteredItemsCountQuery} from '../../../queries/filtered-items-count-query'
import {useAutomationGraph} from '../../../state-providers/workflows/use-automation-graph'
import {getContentTypes, SEARCH_DEBOUNCE_DELAY_MS} from '../helpers/search-constants'

export const useGetProjectItemsAction = () => {
  const {setFilterCount, localQuery, setLocalQuery, setLocalContentTypes} = useAutomationGraph()

  const [debouncedQuery, setDebouncedQuery] = useState(localQuery)
  const debouncedSearch = useMemo(
    () =>
      debounce((newQuery: string) => {
        setLocalContentTypes(getContentTypes(newQuery))
        setDebouncedQuery(newQuery)
      }, SEARCH_DEBOUNCE_DELAY_MS),
    [setLocalContentTypes],
  )

  const {data: count} = useFilteredItemsCountQuery(debouncedQuery)

  const onSearchQueryChange = useCallback(
    (newQuery: string) => {
      debouncedSearch.cancel()
      setLocalQuery(newQuery)
    },
    [debouncedSearch, setLocalQuery],
  )

  useEffect(() => {
    setFilterCount(count ?? 0)
  }, [count, setFilterCount])

  useEffect(() => {
    // debouncedSearch should be called whenever localQuery changes
    // and localQuery can be modified outside of this hook
    // so we use a useEffect to listen for changes to localQuery
    // instead of calling debouncedSearch directly in onSearchQueryChange
    debouncedSearch(localQuery)
  }, [debouncedSearch, localQuery])

  return {
    onSearchQueryChange,
  }
}
